import { Amplify } from 'aws-amplify';
import config from './aws-exports';

// This module is imported first in index.js so Amplify is configured before any
// store module body runs (useShopSettings, useOperationalStore, etc. call
// generateClient() at module level, which requires configure to have happened).
Amplify.configure(config);
